import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/withdraw/arrowMy.png'


const _hoisted_1 = { class: "bonus-tracker" }
const _hoisted_2 = {
  key: 0,
  class: "progress-bar-bg",
  style: {
          left: `0`,
          right: `0`
        }
}
const _hoisted_3 = { class: "icon-wrapper" }
const _hoisted_4 = ["src"]
const _hoisted_5 = {
  key: 0,
  class: "claimed-badge"
}
const _hoisted_6 = ["onClick"]
const _hoisted_7 = {
  key: 0,
  class: "arrow-icon"
}

import { computed } from 'vue'

import icon1 from '@/assets/themeFour/DayIcon.png'
import icon2 from '@/assets/themeFour/DayIcon2.png'
import icon3 from '@/assets/themeFour/DayIcon3.png'
import icon4 from '@/assets/themeFour/DayIcon4.png'
import icon5 from '@/assets/themeFour/DayIcon5.png'


export default /*@__PURE__*/_defineComponent({
  __name: 'BonusTracker',
  props: {
    dayList: {},
    activeDay: {}
  },
  emits: ['select'],
  setup(__props: any) {

const icons = [icon1, icon2, icon3, icon4, icon5]

const props = __props



const progressPercentage = computed(() => {
  if (!props.dayList || props.dayList.length <= 1) return 0;
  
  let lastActiveIndex = -1;
  
  // progressed to (0 = completed/expired, 1 = today)
  for (let i = props.dayList.length - 1; i >= 0; i--) {
    const status = props.dayList[i].reward_data?.activeStatus;
    if (status === 0 || status === 1) {
      lastActiveIndex = i;
      break;
    }
  }

  if (lastActiveIndex <= 0) return 0;
  return (lastActiveIndex / (props.dayList.length - 1)) * 100;
})

return (_ctx: any,_cache: any) => {
  const _component_van_progress = _resolveComponent("van-progress")!
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_col = _resolveComponent("van-col")!
  const _component_van_row = _resolveComponent("van-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_van_row, {
      wrap: false,
      class: "tracker-row"
    }, {
      default: _withCtx(() => [
        (_ctx.dayList && _ctx.dayList.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(_component_van_progress, {
                percentage: progressPercentage.value,
                "show-pivot": false,
                color: "#f5c84c",
                "track-color": "#1a1a2e",
                "stroke-width": "10px"
              }, null, 8, ["percentage"])
            ]))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dayList, (item, index) => {
          return (_openBlock(), _createBlock(_component_van_col, {
            key: index,
            class: "tracker-col"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", {
                class: _normalizeClass(['chest-container', { active: _ctx.activeDay === item.reward_day }])
              }, [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("img", {
                    src: icons[Math.min(index, 4)],
                    class: "chest-icon"
                  }, null, 8, _hoisted_4),
                  (item.reward_data?.rewardCoin)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                        _createVNode(_component_van_icon, { name: "success" })
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", {
                  class: "day-label",
                  onClick: ($event: any) => (_ctx.$emit('select', item))
                }, _toDisplayString(_ctx.$t('common.travel')) + " " + _toDisplayString(item.reward_day), 9, _hoisted_6),
                (_ctx.activeDay === item.reward_day)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, _cache[0] || (_cache[0] = [
                      _createElementVNode("img", {
                        style: {"width":"15px"},
                        src: _imports_0,
                        alt: "arrow"
                      }, null, -1)
                    ])))
                  : _createCommentVNode("", true)
              ], 2)
            ]),
            _: 2
          }, 1024))
        }), 128))
      ]),
      _: 1
    })
  ]))
}
}

})